import { DialogTitle, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

interface ModalHeaderProps {
    onClose: () => void;
}

const ModalHeader = ({ onClose }: ModalHeaderProps) => {
    return (
        <DialogTitle sx={{
            m: 0,
            p: 2,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            fontSize: '20px',
            fontWeight: 600,
            borderBottom: '1px solid #333',
            backgroundColor: '#1e1e1e'
        }}>
            <span>جزئیات</span>
            <IconButton
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    left: 8,
                    top: 8,
                    color: '#999',
                    '&:hover': { color: '#fff' }
                }}
            >
                <CloseIcon />
            </IconButton>
        </DialogTitle>
    );
};

export default ModalHeader;